import React, {useCallback, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {labels} from '../../../../../util/utils';
import Utility from '../../../../../util/utilityfunctions';
import EllipsesControl from '../../../../Common/EllipsesControl/EllipsesControl';
import {StyledLinkLabel} from '../../../StyledElements/StyledElements';
import {useQuery} from '../../../../../util/customHooks';

function RiskFactorsRedirectLink({engagementId}) {
	const navigate = useNavigate();

	const queryParameters = useQuery();

	let riskFactorsSlice = useSelector((state) => state.aresFormDataByBodyTypeId);

	//<summary>In order to redirect an user to an 87 formbody, we need its document to have system associated tasks related to it.</summary>
	//<returns>The riskFactor or undefined if no risk factor matches the specified criteria.</returns>
	const getRedirectableRiskFactor = useCallback(() => {
		let riskFactor;
		let index = 0;

		do {
			let item = riskFactorsSlice.byId[riskFactorsSlice.allIds[index]];
			let tasks = item.document?.tasks;

			if (getSystemAssociatedTask(tasks) !== undefined) {
				riskFactor = item;
			}

			index++;
		} while (riskFactor === undefined && index < riskFactorsSlice.allIds.length);

		return riskFactor;
	}, [riskFactorsSlice]);

	const getSystemAssociatedTask = useCallback((tasks) => {
		let _tasks = tasks ?? [];

		return _tasks.filter((t) => t.isSystemAssociated).pop();
	}, []);

	let riskFactor = useMemo(() => {
		return getRedirectableRiskFactor();
	}, [riskFactorsSlice]);

	let task = useMemo(() => {
		return getSystemAssociatedTask(riskFactor?.document?.tasks);
	}, [riskFactor]);

	const redirectUserToRiskFactor = useCallback(() => {
		const documentId = riskFactor.document?.id;
		let headerId = riskFactor.headerId;
		let sectionId = riskFactor.sectionId;

		navigate(
			Utility.getAresTaskListNavigationUrl(
				documentId,
				headerId,
				sectionId,
				engagementId,
				task.id || task.taskId,
				queryParameters
			)
		);
	}, [riskFactor, task]);

	return (
		<React.Fragment>
			{task && (
				<StyledLinkLabel onClick={redirectUserToRiskFactor}>
					<EllipsesControl
						content={labels.completeRiskFactorAssessment}
						tooltip={labels.completeRiskFactorAssessment}
						ellipsisClass={'risk-factors-redirect-link'}
						noOfLines={1}
					/>
				</StyledLinkLabel>
			)}
		</React.Fragment>
	);
}

export default RiskFactorsRedirectLink;
